import React from "react";
import { CheckCircle2Icon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  note?: string;
  noteTone?: "light" | "dark";
};
export function CtaButton({
  label,
  id,
  note,
  noteTone = "light"
}: CtaButtonProps) {
  const handleClick = () => {
    window.fbq?.("track", "InitiateCheckout");
  };
  return <div className="mx-auto flex w-full max-w-xl flex-col items-center" data-id="element-85" data-mp="qkagr5ve53tw">
      <a id={id} href={CHECKOUT_URL} onClick={handleClick} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center font-sans text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_10px_24px_-8px_rgba(21,128,61,0.65)] transition-[transform,background-color] duration-150 ease-out hover:bg-cta-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:px-8 sm:py-6 sm:text-xl" data-id="element-86" data-mp="qi7g7rwm3sax">
        <CheckCircle2Icon className="h-7 w-7 shrink-0" aria-hidden="true" data-id="element-87" data-mp="35xo0awkn46kf" />
        <span data-id="element-88" data-mp="39yrg5j2ou2ln">{label}</span>
      </a>
      {note && <p className={`mt-3 text-center text-sm leading-relaxed ${noteTone === "light" ? "text-ink-soft" : "text-wine-100"}`} data-id="element-89" data-mp="39zj1m12kmjy7">
          {note}
        </p>}
    </div>;
}